import { render, staticRenderFns } from "./Piutang.vue?vue&type=template&id=0ebd7044&"
import script from "./Piutang.vue?vue&type=script&lang=js&"
export * from "./Piutang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Piutang.vue"
export default component.exports